<div *ngIf="reportePBI" style="width: 100%; height: 1000px; border: none;">
  <iframe 
    [src]="reportePBI | safeUrl" 
    style="width: 100%; height: 100%; border: none;">
  </iframe>
</div>

<div *ngIf="!reportePBI" style="display: flex; justify-content: center; align-items: center; height: 100vh;">
  <div style="text-align: center;">
    <h2 style="color: #666; font-size: 24px;">No hay reporte PBI configurado para esta encuesta</h2>
  </div>
</div>
